<template>
	<div id="app">
		<nav class="site-navbar">
			<div style="width: 100%;min-height: 100px;height: auto;display:flex;align-items: center;border-bottom: 1px solid #e6e6e6;">
				<h1 style="font-size: 50px;margin-right: auto;margin-top: 10px;margin-bottom: 10px;"><img
						src="./assets/logo.png" width="50px" height="50px" /> Intermittent Fasting Calculator</h1>
						<h2 style="margin-right: auto;color: white;">fasting weight loss calculator</h2>
				<!-- <el-menu mode="horizontal" style="margin-left: auto">
			  <el-submenu index="1">
			    <template slot="title">English</template>
			    <el-menu-item index="1-1">Deutsch</el-menu-item>
			  </el-submenu>
			</el-menu> -->
			</div>
		</nav>
		<div id="main">
			<h2 style="color: white;">Intermittent Fasting Calculator</h2>
			<el-form ref="form" :model="form" label-position="top" style="text-align: left;width: 360px;height: 380px;">
				<el-form-item label="Last Meal Time:">
					<el-time-picker v-model="form.lastMealTime" format="HH:mm" value-format="HH:mm" style="width: 320px">
					</el-time-picker>
				</el-form-item>
				<el-form-item label="Fasting Duration (in hours):">
					<el-input-number v-model="form.fastingHours" controls-position="right" :min="1"
						style="width: 320px"></el-input-number>
				</el-form-item>
				<el-button type="primary" @click="calculate()" style="margin-left: 20px;font-size: 16px;">Calculate Next
					Meal</el-button>
				<el-form-item label="Your next meal should be at:">
					<span style="color: #409EFF;font-size: 20px;font-weight: bold;">{{ form.result }}</span>
					<el-button type="primary" @click="copyToClipboard()"
						style="float:right;margin-right: 20px;font-size: 16px;">Copy</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div id="content" style="width: 80%;margin-left: auto;margin-right: auto;">
			<h2>What is Intermittent Fasting?</h2>
			<p>Intermittent fasting (IF) is an eating pattern that alternates between periods of eating and fasting.
				It's not about what you eat but when you eat. There are several different methods, but all involve
				choosing specific times for eating and fasting to optimize health, manage weight, and promote various
				metabolic processes.</p>
			<h2>Key Benefits of Intermittent Fasting:</h2>
			<p>● Weight loss: By reducing the eating window, you typically consume fewer calories.</p>
			<p>● Improved metabolic health: IF can improve insulin sensitivity, reduce blood sugar, and enhance fat
				burning.</p>
			<p>● Cellular repair: Fasting initiates important processes such as autophagy, which removes damaged cells.
			</p>
			<p>● Longevity: Some studies suggest fasting might increase lifespan.</p>
			<h2>How to Calculate Intermittent Fasting:</h2>
			<h3>1.Choose a Method</h3>
			<p>● 16/8 Method: Fast for 16 hours, eat within an 8-hour window (e.g., eating between 12 PM and 8 PM).</p>
			<p>● 5:2 Method: Eat normally for five days, but reduce calorie intake to about 500–600 on two
				non-consecutive days.</p>
			<p>● Eat-Stop-Eat: Involves a 24-hour fast once or twice a week.</p>
			<p>● Alternate-Day Fasting: Fasting every other day.</p>
			<p>● Warrior Diet: Fast for 20 hours and eat one large meal at night.</p>
			<h3>2.Determine Your Eating and Fasting Windows</h3>
			<p>● 16/8 Example: If you finish your last meal at 8 PM, you start eating again at 12 PM the next day.</p>
			<p>● 5:2 Example: On fasting days, reduce your intake to a small meal of 500–600 calories.</p>
			<h3>3.Track Your Eating Time Use a simple formula:</h3>
			<p>Fasting hours=24−Eating window hours</p>
			<p>Example: If your eating window is 8 hours, fasting time is:</p>
			<p>24−8=16hours fasting</p>
			<h3>4.Calorie Considerations</h3>
			<p>● You can eat normally during the eating period, but aim for nutritious, balanced meals.</p>
			<p>● On fasting days (for the 5:2 or Eat-Stop-Eat), calculate 25% of your typical calorie intake (about
				500–600 calories) if needed.</p>
			<h2>Tips for Success:</h2>
			<p>● Stay hydrated: Drink water, herbal tea, or black coffee during the fast.</p>
			<p>● Ease into it: Start with a shorter fast, such as 12/12, and gradually work up to longer fasting
				windows.</p>
			<p>● Listen to your body: Hunger will come and go, but don’t ignore fatigue or dizziness.</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				form: {
					lastMealTime: '',
					fastingHours: '',
					result: ''
				}
			}
		},
		created() {
			this.setCurrentTime();
			this.form.fastingHours = 8;
			this.calculate();
		},
		methods: {
			calculate() {
				// Get the time of the last meal from the input field. This is a string in 'HH:MM' format.
				var lastMealTime = this.form.lastMealTime;

				// Get the fasting duration from the input field. This is a string, but we'll use it as a number.
				var fastingHours = this.form.fastingHours;

				// Check if both required inputs are provided.
				// Create a new Date object for the current date and time.
				var lastMealDate = new Date();

				// Split the last meal time string into hours and minutes.
				var timeParts = lastMealTime.split(':');

				// Set the hours and minutes of the Date object to the last meal time.
				lastMealDate.setHours(timeParts[0], timeParts[1]);

				// Calculate the next meal time by adding the fasting duration to the last meal time.
				// We multiply the fasting hours by 60 to get minutes, again by 60 to get seconds, and again by 1000 to get milliseconds,
				// because the argument to the Date.getTime() and the Date.setTime() methods is in milliseconds.
				var nextMealDate = new Date(lastMealDate.getTime() + fastingHours * 60 * 60 * 1000);

				// Format the next meal time as a string and display it in the 'result' element.
				// The toTimeString() method returns a string in 'HH:MM:SS GMT' format, so we split it by space and take the first part to get the 'HH:MM:SS' part.

				const dateFormatter = new Intl.DateTimeFormat('en-US', {
					hourCycle: 'h24',
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
					hour: '2-digit',
					minute: '2-digit'
				});

				const formattedDate = dateFormatter.format(nextMealDate);
				this.form.result = formattedDate;
			},
			setCurrentTime() {
				const now = new Date();
				this.form.lastMealTime = this.padTime(now.getHours()) + ':' + this.padTime(now.getMinutes());
			},
			padTime(time) {
				return time < 10 ? '0' + time : time;
			},
			copyToClipboard() {
				const that = this;
				navigator.clipboard.writeText(this.form.result)
					.then(function() {
						that.$message({
							message: 'Copied next meal time succesfully.',
							type: 'success'
						});
					})
					.catch(function(err) {
						that.$message.error('Copied next meal time fail.');
					});
			}
		}
	}
</script>
<style>
	#main {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 100%;
		width: 360px;
		border-radius: 10px;
		box-shadow: 10px 10px 5px grey;
		text-align: center;
		margin: auto;
		background-color: #409EFF;
	}

	.site-navbar {
		margin-bottom: 20px;
		min-height: 100px;
		height: auto;
	}

	.el-form {
		background-color: white;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
	}

	.el-form-item {
		margin-left: 20px;

		label {
			font-weight: bold;
			font-size: 16px;
		}
	}

	.el-input-number .el-input__inner {
		text-align: left;
		font-size: 16px;
	}

	.el-form-item__content .el-input__inner {
		font-size: 16px;
	}

	.el-time-panel .el-time-spinner__item {
		font-size: 16px;
	}

	.el-submenu__title {
		font-size: 16px;
	}

	.el-menu.el-menu--horizontal {
		border-bottom: none;
	}

	#content h2 {
		font-size: 30px;
	}

	#content h3 {
		font-size: 24px;
	}

	#content p {
		font-size: 20px;
	}
</style>